import React from 'react';
import { Dropdown, Button } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

/**
 * Standalone language dropdown for surfaces that DON'T render inside
 * AppLayout (login, register, magic-link, password reset, etc.).
 * Falls back to plain Chinese-only when the i18n locale is missing.
 *
 * AppLayout already renders an equivalent dropdown inline in its header
 * — this component is the auth-page equivalent. Single source of truth
 * for the language-choice payload (which locales we support, their
 * labels, how they get applied to i18next).
 */
export const LanguageToggle: React.FC<{ className?: string }> = ({ className }) => {
    const { t, i18n } = useTranslation();

    return (
        <Dropdown
            menu={{
                items: [
                    { key: 'zh', label: t('common.language_zh'), onClick: () => i18n.changeLanguage('zh') },
                    { key: 'en', label: t('common.language_en'), onClick: () => i18n.changeLanguage('en') },
                ],
                selectedKeys: [i18n.language],
            }}
            placement="bottomRight"
        >
            <Button type="text" icon={<GlobalOutlined />} className={className}>
                {i18n.language === 'en' ? 'EN' : '中文'}
            </Button>
        </Dropdown>
    );
};
